import React, { lazy, Suspense } from 'react';
import { Capacitor } from '@capacitor/core';
import type { ARRoomScan } from '../types';

// Type from ar-noor-room plugin (only import type, not runtime)
type ARMultiRoomScanResult = any; // Will be properly typed when plugin loads on native

interface NativeARRoomScannerProps {
  onScanComplete: (scan: ARRoomScan) => void;
  onClose: () => void;
  onIntegrateToFloorPlan: (scan: ARRoomScan) => void;
  onMultiRoomIntegrate?: (result: ARMultiRoomScanResult) => void;
}

// Lazy load the native scanner only on native platforms
const NativeARRoomScanner = Capacitor.isNativePlatform()
  ? lazy(() => import('./NativeARRoomScanner'))
  : null;

const NativeARRoomScannerWrapper: React.FC<NativeARRoomScannerProps> = (props) => {
  // Don't render anything on web - this should never be called on web anyway
  if (!Capacitor.isNativePlatform() || !NativeARRoomScanner) {
    console.warn('[NativeARRoomScanner] Attempted to render on non-native platform');
    return null;
  }

  return (
    <Suspense fallback={<div>Loading scanner...</div>}>
      <NativeARRoomScanner {...props} />
    </Suspense>
  );
};

export default NativeARRoomScannerWrapper;
